// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Cloud Costs API
 * API to get cloud cost information about Aura components and dev environments. Is used by the Aura Portal.
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 */
export const ApitypesCloudProvider = {
  CloudProviderGCP: 'gcp',
  CloudProviderAWS: 'aws',
  CloudProviderAzure: 'azure',
} as const;
export type ApitypesCloudProvider =
  (typeof ApitypesCloudProvider)[keyof typeof ApitypesCloudProvider];

export function instanceOfApitypesCloudProvider(value: any): boolean {
  for (const key in ApitypesCloudProvider) {
    if (Object.prototype.hasOwnProperty.call(ApitypesCloudProvider, key)) {
      if (
        ApitypesCloudProvider[key as keyof typeof ApitypesCloudProvider] ===
        value
      ) {
        return true;
      }
    }
  }
  return false;
}

export function ApitypesCloudProviderFromJSON(
  json: any,
): ApitypesCloudProvider {
  return ApitypesCloudProviderFromJSONTyped(json, false);
}

export function ApitypesCloudProviderFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ApitypesCloudProvider {
  return json as ApitypesCloudProvider;
}

export function ApitypesCloudProviderToJSON(
  value?: ApitypesCloudProvider | null,
): any {
  return value as any;
}

export function ApitypesCloudProviderToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): ApitypesCloudProvider {
  return value as ApitypesCloudProvider;
}
